import { z } from 'zod';

export const WorkflowStore = z.object({
  storeId: z.string(),
  storeName: z.string(),
});

export type WorkflowStore = z.infer<typeof WorkflowStore>;
